// Used to trigger non-recoverable application errors with custom friendly messaging
// Use Error('my friendly message', {cause: originalError}) in case the error was re-thrown.
class ApplicationError extends Error {}

export default ApplicationError
